import { AuthContext, } from "@/shared/presentation/context-api/providers/auth";
import React, { useContext, useEffect, useMemo, useState } from "react";
var initialState = {
    clientWallet: undefined,
    clientWallets: [],
    setSelectedClientWallet: function () { return null; },
};
export var ClientWalletContext = React.createContext(initialState);
export var ClientWalletProvider = function (_a) {
    var children = _a.children, entityDatasource = _a.entityDatasource;
    var _b = useContext(AuthContext), authClients = _b.clientWallets, rockId = _b.rockId, isEntityStandalone = _b.isEntityStandalone;
    var _c = useState(), clientWallet = _c[0], setClientWallet = _c[1];
    var _d = useState(), employeeDetailed = _d[0], setEmployeeDetailed = _d[1];
    var setSelectedClientWallet = function (newClientWallet) {
        setClientWallet(newClientWallet);
    };
    var clientWallets = useMemo(function () {
        if (!employeeDetailed)
            return [];
        var clients = employeeDetailed.clients;
        return clients.map(function (client) {
            var authClient = authClients.find(function (authClient) { return authClient.rockId === client.rockId; });
            return {
                walletUuid: authClient === null || authClient === void 0 ? void 0 : authClient.walletUuid,
                rockId: client.rockId,
                name: client.name,
            };
        });
    }, [employeeDetailed]);
    useEffect(function () {
        if (rockId && !isEntityStandalone) {
            entityDatasource.getEmployeesDetailed(rockId).then(setEmployeeDetailed);
        }
    }, [authClients]);
    useEffect(function () { return setClientWallet(clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]); }, [clientWallets]);
    return (React.createElement(ClientWalletContext.Provider, { value: {
            clientWallet: clientWallet,
            clientWallets: clientWallets,
            setSelectedClientWallet: setSelectedClientWallet,
        } }, children));
};
